var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.28v3.462a2.305 2.305 0 0 1-1.573 2.196 2.317 2.317 0 0 1-.949.113 22.916 22.916 0 0 1-9.98-3.543 22.529 22.529 0 0 1-6.938-6.925A22.811 22.811 0 0 1 1.01 3.576a2.304 2.304 0 0 1 1.368-2.319c.294-.13.612-.197.933-.197H6.78a2.316 2.316 0 0 1 2.313 1.985c.146 1.108.418 2.196.81 3.243a2.304 2.304 0 0 1-.521 2.436l-1.469 1.465a18.484 18.484 0 0 0 6.939 6.925l1.469-1.466a2.315 2.315 0 0 1 2.44-.519c1.049.39 2.139.662 3.25.808A2.306 2.306 0 0 1 24 18.28Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPhone;